import * as React from 'react'

import { styled } from '~/styled'

const StyledTextarea = styled('textarea', {
  base: [
    'shadow-none',
    'appearance-none',
    'rounded-md',
    'box-border',
    'text-grey-1000',
    'font-body',
    'font-normal',
    'text-md',
    'leading-[1.4]',
    'm-0',
    'min-h-24',
    'px-3',
    'py-3',
    'resize-y',
    'w-full',
    'disabled:bg-grey-200',
    'disabled:cursor-not-allowed',
    'disabled:text-grey-800',
    'placeholder:opacity-100',
    'placeholder:text-grey-700'
  ],
  variants: {
    appearance: {
      standard: [
        'bg-white',
        'border',
        'border-grey-800',
        'focus-within:border-primary-800',
        'focus-within:outline-none'
      ],
      modern: [
        'bg-grey-100',
        'border-none',
        'focus-within:outline-2',
        'focus-within:outline-blue-800',
        'focus-within:outline-offset-1',
        'focus-within:outline-solid',
        'focus-within:z-1'
      ]
    },
    state: {
      error: []
    },
    theme: {
      white: [],
      grey: []
    }
  },
  defaultVariants: {
    appearance: 'standard'
  },
  compoundVariants: [
    {
      state: 'error',
      appearance: 'standard',
      class: ['border-danger']
    },
    {
      state: 'error',
      appearance: 'modern',
      class: ['bg-danger-light', 'focus-within:outline-danger']
    },
    {
      appearance: 'modern',
      theme: 'white',
      class: ['bg-white']
    },
    {
      appearance: 'modern',
      theme: 'grey',
      class: ['bg-grey-100']
    }
  ]
})

export type TextareaProps = React.ComponentProps<typeof StyledTextarea>

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  (props, ref) => <StyledTextarea {...props} ref={ref} />
)

Textarea.displayName = 'Textarea'
